import { Stack } from "@mantine/core";
import { UserSubscribeTopicNode } from "shared/components/organization/topics/UserSubscribeTopicNode";
import { features } from "shared/graphql/features";
import { useAddUserToTopic, useRemoveUserFromTopic } from "shared/graphql/topics";
import { useUser } from "shared/graphql/users";
import { useUserId } from "shared/stores/oidc";

export const TopicsContainer = () => {
    features.useGuard("HAS_TOPICS");

    const { user } = useUser();
    const { userId } = useUserId();

    const { addUser } = useAddUserToTopic();
    const { removeUser } = useRemoveUserFromTopic();

    return (
        <Stack gap={0}>
            <UserSubscribeTopicNode
                defaultCheckedTopics={user?.topics.filter((it) => !it.isRequired) ?? []}
                checkboxOnChange={(topic, checked) => {
                    if (checked) {
                        addUser({ userId, topicId: topic.id });
                    } else {
                        removeUser({ userId, topicId: topic.id });
                    }
                }}
            />
        </Stack>
    );
};
